module.exports = __webpack_public_path__ + "static/img/pic_phone_5.24d3e1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/pic_phone_5.png
// module id = pn7F
// module chunks = 1